import React, { useState } from 'react';
import axios from 'axios';
import "./Login.css";

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL
const Login = ({ onLogin }) => {
  const [user, setUser] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      // Solicitar el token al backend
      const response = await axios.post(`${SOCKET_URL}/api/request-token`, {
        user,
        password,
      });

      if (response.data.success) {
        const token = response.data.token;

        // Almacenar el token en localStorage
        localStorage.setItem('authToken', token);

        // Llamar la función de callback para manejar el inicio de sesión
        onLogin(token);
      } else {
        setError(response.data.error || 'Invalid credentials');
      }
    } catch (err) {
      setError('Ha ocurrido un error mientra iniciaba sesión.');
      console.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <h2 className="login-title">¡Bienvenido al chat!</h2>
      <p className="login-subtitle">Inicia sesión para continuar...</p>
      <form className="login-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="username">Nombre de usuario</label>
          <input
            id="username"
            type="text"
            value={user}
            onChange={(e) => setUser(e.target.value)}
            className="form-input"
            placeholder="Enter your username"
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="password">Contraseña</label>
          <input
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="form-input"
            placeholder="Enter your password"
            required
          />
        </div>
        {error && <p className="form-error">{error}</p>}
        <button type="submit" className="login-button" disabled={loading}>
          {loading ? 'Logging in...' : 'Login'}
        </button>
      </form>
    </div>
  );
};

export default Login;
